import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IUpdatePendenciesRequest } from "../interface/trade/IUpdatePendenciesRequest";
import { IBaseResponse } from "../interface/IBaseResponse";
import { ITradePendencyCategory } from "../interface/Pendency/ITradePendencyCategory";
import { ITradePendency } from "../interface/trade/ITradePendency";
import { saveByteArray } from 'src/util/saveByteArray';

enum PendencyServiceEnum {
  updatePendencies = "/update-pendencies",
  getPendencyCategories = "/get-pendency-categories?",
  getPendenciesByTradeId = "/get-pendencies-by-trade-id/",
  downloadSolutionFile = "/download-solution-file"
}
export default class PendencyService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/pendency");
  }

  public updatePendencies = async (data: IUpdatePendenciesRequest): Promise<IBaseResponse> => await this.PUT(PendencyServiceEnum.updatePendencies, data);
  public getPendencyCategories = async (): Promise<ITradePendencyCategory[]> => await this.GET(PendencyServiceEnum.getPendencyCategories);
  public getPendenciesByTradeId = async (tradeId: number): Promise<ITradePendency[]> => await this.GET(PendencyServiceEnum.getPendenciesByTradeId + tradeId);
  public downloadSolutionFile = async (fileKey: string, filename: string) => {
    const data = await this.POST(`${PendencyServiceEnum.downloadSolutionFile}/${fileKey}`, {}, "blob");
    saveByteArray(filename, data);
    return data;
  }
}
